import React from "react";
import { Briefcase } from "lucide-react";

/**
 * Branded PropertyConnect recruitment fallback creative (navy/gold, never black).
 * Shown when a recruitment opportunity has no uploaded cover. Communicates
 * "WE'RE RECRUITING", the role/title and organization/team, with subtle branding.
 */
export function RecruitmentFallback({ title, org, typeLabel, variant = "card", className = "" }) {
  const hero = variant === "hero";
  return (
    <div
      data-testid="recruitment-fallback"
      className={`relative w-full h-full overflow-hidden bg-gradient-to-br from-[#0F2C59] via-[#123566] to-[#16407f] ${className}`}
    >
      {/* soft gold glow + faint grid texture */}
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#C79A3B]/25 blur-3xl" />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)",
          backgroundSize: hero ? "40px 40px" : "28px 28px",
        }}
      />
      <div className={`relative h-full flex flex-col justify-center ${hero ? "px-8 py-9 sm:px-12" : "px-5 py-5"}`}>
        <div className="flex items-center gap-2">
          <span className={`flex items-center justify-center rounded-lg bg-[#C79A3B] ${hero ? "h-8 w-8" : "h-6 w-6"}`}>
            <Briefcase className={hero ? "h-4.5 w-4.5 text-[#0F2C59]" : "h-3.5 w-3.5 text-[#0F2C59]"} />
          </span>
          <span className={`font-bold uppercase tracking-[0.18em] text-[#E9C879] ${hero ? "text-sm" : "text-[11px]"}`}>
            We're Recruiting
          </span>
        </div>
        {typeLabel && (
          <span className={`mt-3 inline-block w-fit rounded-full bg-white/10 font-semibold text-white/85 ${hero ? "text-xs px-3 py-1" : "text-[10px] px-2 py-0.5"}`}>
            {typeLabel}
          </span>
        )}
        {title && (
          <h3 className={`mt-2.5 font-display font-bold text-white ${hero ? "text-2xl sm:text-3xl line-clamp-3" : "text-lg leading-snug line-clamp-2"}`}>
            {title}
          </h3>
        )}
        {org && (
          <p className={`mt-1 font-medium text-white/70 ${hero ? "text-sm" : "text-xs"} line-clamp-1`}>{org}</p>
        )}
      </div>
      <div className={`absolute right-4 ${hero ? "bottom-5" : "bottom-3"} flex items-center gap-1.5`}>
        <span className={`rounded-sm bg-[#C79A3B] ${hero ? "h-2.5 w-2.5" : "h-2 w-2"}`} />
        <span className={`font-semibold tracking-wide text-white/55 ${hero ? "text-xs" : "text-[10px]"}`}>PropertyConnect</span>
      </div>
    </div>
  );
}

export default RecruitmentFallback;
